
import { createRouter, createWebHistory } from 'vue-router'

import routerList from './routerList'
import { createApp } from 'vue'
const app = createApp({})

const routes = [
    {
        path: '/',
        component: () => import('@/views/home'),
        redirect: '/index',
        children: routerList(),
    },
    // {
    //     path: '/404',
    //     component: () => import('@/views/404/index'),
    // },
    // {
    //     path: '/login',
    //     component: () => import('@/views/user/login'),
    // },
]

const router = createRouter({
    history: createWebHistory(),
    scrollBehavior: () => ({ y: 0 }),
    routes,
})

app.use(router)

export default router
